import { Button, type ButtonProps, Container, Typography } from "@octopus-energy/coral/atoms"
import { type MenuItem } from "@/features/navigation/types/menuItem"

function DashboardMenuSubItem({ subItem, ...buttonProps }: { subItem: MenuItem } & ButtonProps) {
    return (
        <Container marginLeft="sm">
            <MenuButton
                href={subItem.href}
                {...buttonProps}
            >
                {subItem.label}
            </MenuButton>
        </Container>
    )
}

import { type PropsWithChildren } from "react"

function MenuButton({ children, ...props }: PropsWithChildren<ButtonProps>) {
    return (
        <Button
            variant="ghost"
            color="secondary500"
            size="small"
            {...props}
        >
            <Typography
                color="inherit"
                textStyle="body2"
                component="span"
            >
                {children}
            </Typography>
        </Button>
    )
}

export const MenuSub = {
    Button: MenuButton,
    Item: DashboardMenuSubItem,
}
